import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { EntryService } from 'services/entry/entry.service';
import { Observable } from 'rxjs';

@Injectable()
export class FirstLoginResolverService  {
  constructor(private entryService: EntryService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const role = route.params.role;

    if (role === 'professional') {
      return this.entryService.getProfessionalRegister();
    } else {
      return this.entryService.getOrganizationRegister(this.entryService.getMessageType().organization_sign_up_data_id);
    }
  }
}

export const firstLoginResolver: ResolveFn<Observable<any>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(FirstLoginResolverService).resolve(route);
};
